export enum BoxType {
  SAVER_BOX = 'saver_box',
  FLEX_BOX = 'flex_box',
}

export type BoxWithPlan = {
  boxId: string
  boxName: string
  boxDisplayName: string
  boxType: BoxType
  description: string
  weightLb: number
  weightOz: number
  boxPlan: BoxPlan[]
  frequency: number
}

export type Box = {
  boxId: string
  boxName: string
  boxDisplayName: string
  boxType: BoxType
  description: string
  weightLb: number
  weightOz: number
}

export type BoxPlan = {
  boxPlanId: number
  boxId: string
  planId: string
  defaultPrice: number
  proteinCode?: string
  description?: string
}
